export default "__VITE_ASSET__C9i4y7ho__"